import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as AttachmentActions from '../attachments/attachments.actions';
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  tap,
  throttleTime,
} from 'rxjs/operators';
import { from, Observable, of } from 'rxjs';
import {
  HideSpinner,
  ShowSpinner,
} from '../../../shared/spinner/spinner.action';
import { Action } from '@ngrx/store';
import * as ErrorActions from '../../error/error.actions';
import { ErrorType } from '../../error/model/error-type';
import { AlertMessageCommonService } from '../../../shared/alert-message-common/alert-message-common.service';
import { ServiceOrderService } from '../../backend/service-order/service-order.service';

type showSpinnerTypes = AttachmentActions.AttachmentGetRequest;

const showSpinnerActions = [AttachmentActions.ATTACHMENT_GET_REQUEST];

type hideSpinnerTypes = AttachmentActions.AttachmentGetReceive;

const hideSpinnerActions = [AttachmentActions.ATTACHMENT_GET_RECEIVE];

@Injectable()
export class AttachmentEffects {
  constructor(
    private actions$: Actions,
    private serviceOrderService: ServiceOrderService,
    private alertMessageCommonService: AlertMessageCommonService
  ) {}

  @Effect()
  showSpinner: Observable<Action> = this.actions$.pipe(
    ofType<showSpinnerTypes>(...showSpinnerActions),
    map(() => new ShowSpinner())
  );

  @Effect()
  hideSpinner: Observable<Action> = this.actions$.pipe(
    ofType<hideSpinnerTypes>(...hideSpinnerActions),
    map(() => new HideSpinner())
  );

  @Effect()
  OnAttachmentGetRequest$ = this.actions$.pipe(
    ofType<AttachmentActions.AttachmentGetRequest>(
      AttachmentActions.ATTACHMENT_GET_REQUEST
    ),
    map((action) => action.payload),
    throttleTime(2000),
    switchMap((payload) =>
      from(this.serviceOrderService.workOrderGetAttachment(payload)).pipe(
        mergeMap((AttachmentList) => [
          new AttachmentActions.AttachmentGetReceive({
            AttachmentList: AttachmentList,
            isScrolled: payload.isScrolled,
          }),
        ]),
        catchError((data) =>
          of(
            new ErrorActions.ErrorReceive({
              message: data.error.message,
              type: ErrorType.token,
              statusCode: data.status,
            })
          )
        )
      )
    )
  );
}
